var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ia-cliente-painel" },
    [
      _c("IaClienteCabecalho", {
        staticClass: "ia-cliente-painel__bloco py-4",
        attrs: { navegavel: "", cliente: _vm.cliente, modo: _vm.modo },
        on: {
          abrir: function($event) {
            return _vm.$emit("abrir-perfil", _vm.cliente)
          }
        }
      }),
      _c("IaClienteCarteira", {
        staticClass: "ia-cliente-painel__bloco py-4",
        attrs: {
          navegavel: "",
          ativos: _vm.ativos,
          serie: _vm.serie,
          variacao: _vm.variacao,
          carregando: _vm.carregando
        },
        on: {
          abrir: function($event) {
            return _vm.$emit("abrir-carteira", _vm.cliente)
          }
        }
      }),
      _c("IaClienteTarefas", {
        staticClass: "ia-cliente-painel__bloco py-4",
        attrs: {
          navegavel: "",
          grupos: _vm.gruposDeTarefa,
          carregando: _vm.carregando
        },
        on: {
          abrir: function($event) {
            return _vm.$emit("abrir-tarefas", _vm.cliente)
          }
        }
      }),
      _c("IaClienteContatos", {
        staticClass: "ia-cliente-painel__bloco py-4",
        attrs: {
          navegavel: "",
          timeline: _vm.timeline,
          carregando: _vm.carregando
        },
        on: {
          abrir: function($event) {
            return _vm.$emit("abrir-contatos", _vm.cliente)
          }
        }
      }),
      _c(
        "div",
        {
          staticClass: "ia-cliente-painel__bloco ia-cliente-painel__linha py-4"
        },
        [
          _c("IaClienteContratos", {
            staticClass: "ia-cliente-painel__coluna",
            attrs: {
              navegavel: "",
              contratos: _vm.contratos,
              carregando: _vm.carregando
            },
            on: {
              abrir: function($event) {
                return _vm.$emit("abrir-contratos", _vm.cliente)
              }
            }
          }),
          _c("IaClienteTranscricoes", {
            staticClass: "ia-cliente-painel__coluna",
            attrs: {
              navegavel: "",
              transcricoes: _vm.transcricoes,
              carregando: _vm.carregando
            },
            on: {
              abrir: function($event) {
                return _vm.$emit("abrir-transcricoes", _vm.cliente)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }